import { ANI_ROUTER } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import PlanList from "Components/Shared/PlanList";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React from "react";
import { Divider, Form, Header, Segment } from "semantic-ui-react";

const AniRouterCreate = () => {
  const { save, nextExtension, validateExtension, validateName } = useDevice();

  const initValues = {
    type: ANI_ROUTER,
    name: "",
    extension: nextExtension,
    aniRouter: {
      options: [{ option: "441", connectTo: "HANGUP" }],
      connectTo: "HANGUP",
    },
  };

  return (
    <Segment>
      <Header as='h3'>Create ANI Router</Header>
      <Divider />
      <Formik
        initialValues={initValues}
        onSubmit={(values, actions) => {
          save(values);
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Field
              name='name'
              label='Name'
              validate={validateName}
              component={CallableInput}
            />
            <Field
              name='extension'
              label='Extension'
              placeholder='100'
              type='number'
              validate={validateExtension}
              component={CallableInput}
            />
            <PlanList name='aniRouter.options' />
            <FormSubmit name='Create' errors={props.errors} />
          </Form>
        )}
      </Formik>
    </Segment>
  );
};

export default AniRouterCreate;
